import { render, staticRenderFns } from "./PortalAccessCard.vue?vue&type=template&id=7335cb6b&scoped=true&"
import script from "./PortalAccessCard.vue?vue&type=script&lang=ts&"
export * from "./PortalAccessCard.vue?vue&type=script&lang=ts&"
import style0 from "./PortalAccessCard.vue?vue&type=style&index=0&id=7335cb6b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7335cb6b",
  null
  
)

export default component.exports